import { render, staticRenderFns } from "./LeaveTypeList.vue?vue&type=template&id=e0c081ea"
import script from "./LeaveTypeList.vue?vue&type=script&lang=js"
export * from "./LeaveTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports